export const BREAKPOINTS = {
  base: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export const BREAKPOINT_ORDER = ['base', 'sm', 'md', 'lg', 'xl'] as const;
